import { TooltipProps } from "@mui/material/Tooltip";
import React from "react";

import WarningIcon24 from "assets/icons/WarningIcon24.svg?react";

import Tooltip from "components/Tooltip";

import styles from "./Warning.module.scss";

interface WarningProps {
  messages: React.ReactElement[];
  icon?: React.ReactElement;
  placement?: TooltipProps["placement"];
}

const Warning = (props: WarningProps) => {
  const { messages, icon, placement } = props;

  return (
    <Tooltip
      placement={placement || "top"}
      title={
        <div onClick={e => e.stopPropagation()}>
          {messages.map((message, index) => {
            // eslint-disable-next-line react/no-array-index-key -- it's ok here
            return <div key={index}>{message}</div>;
          })}
        </div>
      }
    >
      <div className={styles.warning}>
        {icon || <WarningIcon24 data-testid="results-warning-icon" />}
      </div>
    </Tooltip>
  );
};

export default Warning;
